<div class="page-container" style="min-height:188.38330078125px">
  <!--Page content -->
  <div class="page-content">
    <div class="panel panel-flat shadow" style="border: none">
      <div class="panel-body">
        <div class="row">
          <div class="form-group">
            <label for="jobNewName" class="col-sm-2 col-xs-3 text-center"><strong translate>New Name</strong></label>
            <div class="col-sm-9 col-xs-8">
              <input id="jobNewName" class="form-control" type="text" [(ngModel)]="jobNewName" >
            </div>
          </div>
        </div>
        <br>
        <div class="row col-sm-10 col-sm-offset-1" [ngClass]="{ 'disabled': reachedMaxUpload || screenState==''}">
          <div class="col-sm-12">
            <!-- Uppy Dashboard for file upload (includes Google Drive and Box) -->
            <uppy-dashboard [uppy]="uppy" [props]="uppyDashboardOptions"></uppy-dashboard>
          </div>
        </div>
        <div class="clearfix"></div>
        <br>
        <div class="row">
          <div class="col-sm-10 col-sm-offset-1">
            <table class="table table-xs table-condensed table-responsive">
              <thead>
                <tr>
                  <th style="width: 30px;"></th>
                  <th><strong translate>Document Name</strong></th>
                  <th><strong translate>Pages</strong></th>
                  <th><strong translate>Size</strong></th>
                  <th></th>
                </tr>
              </thead>
              <tbody cdkDropList [cdkDropListData]="sortableItems" (cdkDropListDropped)="drop($event)">
                <tr *ngFor="let document of sortableItems; let i = index" cdkDrag>
                  <td cdkDragHandle style="cursor: move;"><i class="icon-menu7"></i></td>
                  <td>{{ document.name }}</td>
                  <td>{{ document.page }}</td>
                  <td>{{ document.size }}kb</td>
                  <td>
                    <button type="button" (click)="deleteDocument(document.id, i)" class="btn btn-danger legitRipple btn-xs" [ngClass]="{ 'btn-hide': document.id == mainDocId }">
                      <i class="icon-trash"></i> {{ 'Delete' | translate }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>








